import styled, { keyframes, css } from 'styled-components';
import { SIZE } from 'common/sizes';
import { COLOR_PALETTE } from 'common/colors';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import {RadioOptions, RadioOption, ButtonRadio, ButtonRadioWhite,ButtonRadioInside } from "components/RadioButtonList/styles";

const appear = keyframes`
    from {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    to { transform: translateY(0); opacity: 1;}
`

const appearAnimation = props =>
    css`
    ${appear} 0.350s ease-out;
`
const disappear = keyframes`
    from { transform: translateY(0); opacity: 1;}
    to {transform: translateY(${SIZE.TWENTYFOUR}px); opacity: 0;}
    
`

const disappearAnimation = props =>
    css`
    ${disappear} 0.350s ease-out;
`

export interface ContainerProps {
    shouldShow: boolean;
}
export const Container = styled.div`
    display:flex;
    flex-flow: column;
    background: #FFF;
    width: ${SIZE.EIGHTY_FOUR}px;    
    border: 1px solid #A0A0A0;
    padding: ${SIZE.FIVE}px;
    animation: ${(props: ContainerProps) => props.shouldShow ? appearAnimation : disappearAnimation};
    animation-fill-mode: forwards;
    border-radius: 3px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    
`

export const ErrorMsg = styled.span`
    margin-top: 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    background-image: linear-gradient(to top, #f36868, #f66000);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: flex;
    flex-flow: column;
`


export const Radio = styled.div`
    margin-top:10px;
    ${RadioOptions}{
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
    }
    ${RadioOption}{
        padding-bottom: ${SIZE.TWO}px;

        ${ButtonRadio}{
            height:20px;
            width:20px;
        }
        ${ButtonRadioWhite}
        {
            width: 18px;
            height: 18px;
        }
        ${ButtonRadioInside}
        {
            top: 5px;
            left: 5px;
            height: 10px;
            width: 10px;
            background-color: #ff7319;
        }
    }
`

export const RadioOpt = styled.div`
    margin-top:30px;
    ${RadioOptions}{
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
    }
    ${RadioOption}{
        padding-bottom: ${SIZE.TWO}px;

        ${ButtonRadio}{
            height:20px;
            width:20px;
        }
        ${ButtonRadioWhite}
        {
            width: 18px;
            height: 18px;
        }
        ${ButtonRadioInside}
        {
            top: 5px;
            left: 5px;
            height: 10px;
            width: 10px;
            background-color: #ff7319;
        }
    }
`

export const OptionContainer = styled.div`
    display:flex;
    flex-flow: column;
    width: 100%;    
    height: ${SIZE.FIFTYFOUR}px;    
    
`


export const SeachContainer = styled.div`
    display:flex;
    flex-flow: column;
    width: 100%;
    //height: ${SIZE.THIRTY_FIVE}px;    
    height: ${SIZE.FIFTYFOUR}px;    
`

export const InputSearch = styled.input`    
    width: 96%;
    height: 36px;
    flex-grow: 0;    
    padding: 0px 0px 0px 10px;
    border-radius: 5px;
    border: solid 1px #c5c5c5;
    background-color: #fff;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
`
export const TabBody = styled.div`
    display:flex;    
    flex-flow: row;
    width: 100%;
    height: 100%;    
    overflow-y: scroll;
`

export const LoadContainer = styled.div`
    position:absolute;
    width:85%;
    margin-top:40px;
`

export const EmptyContainer = styled.div`
    position:absolute;
    width:85%;
    margin-top:90px;
    text-align : center;
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;  
    color: #bdbdbd;
`
export const SelectContainer = styled.div`
    display:flex;
    flex-flow: column;
    width: 100%;
    height: ${SIZE.FIFTYFOUR}px;    
`
export const AccountsContainer = styled.div`
    display:flex;    
    flex-flow: row;
    width: 97.5%;
    height: 70%;    
    overflow-y: scroll;
    border-radius: 5px;
    border: solid 1px #bdbdbd;
    margin-top:20px;
    margin-rigth:50px;
`

export const AccountError = styled.div`
    display:flex;    
    flex-flow: row;
    font-family: Rubik;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #b7332b;
    margin: 10px 0 0 10px;
`


export const SimilarText = styled.div`
    display:flex;    
    flex-flow: row;
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;        
    color: #000;


`